import http from '@/service/http'

const save = async (context, obj) => {
  const { verb, arquivoDto } = obj
  const response = await http[verb]('/notaFiscalServico/upload', arquivoDto)

  if (response !== null) {
    return Promise.resolve(response.data)
  }
}

export default {
  save
}



// WEBPACK FOOTER //
// ./src/features/admin/notaFiscal/store/actions.js